import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Clock, CreditCard } from "lucide-react";
import { format } from "date-fns";
import { Expense } from "@/types/expense";

interface RecentTransactionsProps {
  transactions: Expense[];
}

export const RecentTransactions = ({ transactions }: RecentTransactionsProps) => {
  return (
    <Card className="col-span-1 lg:col-span-2 p-4 bg-gradient-to-br from-white to-gray-50">
      <div className="flex items-center gap-2 mb-4">
        <Clock className="h-5 w-5 text-primary" />
        <h3 className="font-semibold">Recent Transactions</h3>
      </div>
      <div className="space-y-3 overflow-x-auto">
        {transactions.map((expense) => (
          <motion.div
            key={expense.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex justify-between items-center p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex items-center gap-3">
              <CreditCard className="h-4 w-4 text-gray-500" />
              <div className="text-left">
                <p className="font-medium">{expense.description}</p>
                <p className="text-sm text-muted-foreground">
                  {format(new Date(expense.date), 'MMM dd, yyyy')}
                </p>
              </div>
            </div>
            <p className="font-semibold text-primary">₹{Number(expense.amount).toFixed(2)}</p>
          </motion.div>
        ))}
      </div>
    </Card>
  );
};